<template>
<div>
	<ihead :checkindex="checkindex"></ihead>
	<div class="banner-box">
		<h1>{{title}}</h1>
	</div>
	<mu-container>
		<mu-breadcrumbs>
			<mu-breadcrumbs-item
				v-for="(item, index) in items"
				:key="index"
				:to="item.to"
				:disabled="item.disabled"
				>{{ item.text }}</mu-breadcrumbs-item
			>
		</mu-breadcrumbs>
	</mu-container>
	<div class='warp'>
		<div class="team-box clearfix" v-for="item in organizationList" :key="item.id">
			<h3>{{item.title}}</h3>
			<ul>
				<li v-for="team in item.institution" :key="team.id">
					<!-- <div class="team-name">{{team.teamName}}</div> -->
					<a href="">
						<img class="team-img" :src="team.picture.path" alt="">
						<div class="overlay-box">
							<div class="overlay-tit">{{team.name}}</div>
							<div class="overlay-content">
								{{team.synopsis}}
							</div>
						</div>
					</a>					
				</li>
			</ul>
		</div>
		<div class="clearfix"></div>
	</div>
	<ifoot></ifoot>
	<returntop class="return-top"></returntop>
</div>
</template>

<script>
import '../assets/css/team.css'
import ihead from "@/components/ihead.vue"
import ifoot from '@/components/ifoot.vue'
import crumbs from "@/components/crumbs.vue"
import returntop from '@/components/returntop'
export default {
	components: {
		ihead,ifoot,crumbs,returntop
	},
	data (){
			return {
				title: '团队组织',
				checkindex:3,
				mainid: this.$route.query.mainid,
				subid: this.$route.query.subid,
				items:[{
					text: '首页',
					disabled: false
				}, {
					text: '慧聚未来',
					disabled: false
				}, {
					text: '团队组织',
					disabled: true
				}],
				organizationList:[
					{   
						id:1,
						title:'研究院',
						institution:[
							{
								id:11,
								name:'中科院上海有机所',
								picture:{
									path:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1585374538323&di=d9265ac8f2fa5c2bec6352fae5c6fee7&imgtype=0&src=http%3A%2F%2Ftm-image.tianyancha.com%2Ftm%2F93df3d37ed15da010d38cf119e6fc3e4.jpg'
								},
								synopsis:'这里是一些简介这里是一些简介这里是一些简介这里是一些简介这里是一些简介这里是一些简介这里是一些简介'
							}
						]
					}              
				]                                     
			}
	},
	created:function(){
		this.getteamList()
	},
	methods: { 
		getteamList(){
			this.$get('/institution/get-institution-list').then(res => {
				if(res.code == 0){
					this.organizationList = res.data
				}else{
					// console.log(res.message)
				}
			})
		}
	},
}
</script>
<style>
	@media screen and ( max-width: 768px){
		.team-box ul li{
			width: 50%;
		}		
		.team-box ul li .team-img {
			width: 90%;			
		}
	}
	@media screen and ( max-width: 320px) {		

	}
</style>
